import { NavigationGuardNext, RouteConfig, Route } from 'vue-router';
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

import { checkPermissions } from '../routeValidation';
import { supportPermission } from './permissions';
import { ROUTES } from './routes';
import { NAVBAR_TYPE_LIGHT } from '@/util/constants/config';

const { SUPPORT_FORM, } = ROUTES;

const SupportForm = () =>
  import(
    /* webpackChunkName: "SupportForm" */
    '@/views/Support/New.vue'
  );

const transactionHistoryRoute: RouteConfig = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: SUPPORT_FORM.route,
      name: SUPPORT_FORM.name,
      component: SupportForm,
      meta: {
        navbarType: NAVBAR_TYPE_LIGHT,
        permissions: supportPermission,
      },
      beforeEnter(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
        checkPermissions(to, from, next);
      },
    }
  ],
};
export default transactionHistoryRoute;
